// extracted by mini-css-extract-plugin
export default {"main":"CategoryCard_main__FHJy9","flex":"CategoryCard_flex__1q6bw","progressBar":"CategoryCard_progressBar__-grE8"};